import api from "apis/inspectorTimeCard";
import {
  REQUEST_FIELD_REP_MANAGERS,
  RECEIVE_FIELD_REP_MANAGERS,
  ERROR_FIELD_REP_MANAGERS,

  REQUEST_INSPECTOR_LIST_SUMMARY,
  RECEIVE_INSPECTOR_LIST_SUMMARY,
  ERROR_INSPECTOR_LIST_SUMMARY,
} from "typeConstants";
import { WebApiReduxRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const getFieldRepManagers = () => WebApiReduxRequest(
  REQUEST_FIELD_REP_MANAGERS,
  RECEIVE_FIELD_REP_MANAGERS,
  ERROR_FIELD_REP_MANAGERS,
  HTTP_GET,
  api.inspectorManagers()
);

export const getInspectorListSummary = (payPeriodId, operationsManagerInternetUserId, operationsDirectorInternetUserId, fieldDevelopmentManagerInternetUserId, isTrainee, roles) => WebApiReduxRequest(
  REQUEST_INSPECTOR_LIST_SUMMARY,
  RECEIVE_INSPECTOR_LIST_SUMMARY,
  ERROR_INSPECTOR_LIST_SUMMARY,
  HTTP_POST,
  api.inspectorListSummary(payPeriodId),
  { 
    payPeriodId,
    employeeRoleList: roles,
    operationsManagerInternetUserId,
    operationsDirectorInternetUserId,
    fieldDevelopmentManagerInternetUserId,
    isTrainee,
  }
);